module.exports = __webpack_public_path__ + "static/media/สั่งซื้อ-02.b7df7441.png";